export default {
  "title": {
    "evolution": "Drowsiness events / 100 hr. daily driving",
    "quantityEvolution": "Total amount of drowsiness events daily",
    "totalEvents": "Total drowsiness events",
    "ranking": "Driver’s ranking"
  },
  "labels": {
    "microsleepsKpi": "Drowsiness events / 100 hr. driving",
    "totalMicrosleeps": "Total drowsiness events",
    "graphTooltip": "Drowsiness events"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/road_warning/detailRoadWarning.js